'use client';
import { useState, useEffect, useRef, useMemo } from 'react';
import React from 'react';
import {
   Box,
   Flex,
   Table,
   Tbody,
   Td,
   Text,
   Tr,
   useColorModeValue,
   useDisclosure,
   Checkbox,
   Drawer,
   DrawerOverlay,
   DrawerContent,
   DrawerCloseButton,
   DrawerHeader,
   DrawerBody,
   useOutsideClick,
   Spinner,
} from '@chakra-ui/react';
import Select from 'react-select';
import 'jspdf-autotable';
import Card from 'components/card/Card';
import { GridItem, Input } from '@chakra-ui/react';
import nodata from 'assets/img/nfts/no data.svg';
import {
   Button,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalFooter,
   ModalBody,
   ModalCloseButton,
   Image,
   Thead,
   Th,
   Grid,
   IconButton,
} from '@chakra-ui/react';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import cancel from '../../../../assets/img/nfts/cancel.svg';
import { getProfitLossMonthly } from '../../../../redux/actions/reports';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
import { SearchIcon } from '@chakra-ui/icons';
import { getShareCompanyOptions } from 'utils/util';
import DotIcon from '../../../../assets/img/nfts/dot.svg';
import { renderDynamicDropdown } from '../../../../components/ui/DynamicDropdown';
import { jsPDF } from 'jspdf';
// import * as XLSX from 'xlsx';
import { motion } from 'framer-motion';
import { LuRefreshCcw } from 'react-icons/lu';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import * as XLSX from 'xlsx-js-style';
import { useGlobal } from 'contexts';
import AccountingReportsFilter from '../components/AccountingReportsFilter';
import { IoFilterOutline } from 'react-icons/io5';
import Loader from 'views/admin/default/Loader';
const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

const ProfitLossMonthly = () => {
   const columnHelper = createColumnHelper();
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
   const controlBg = useColorModeValue('#FFFFFF', '#2D3748');
   const controlBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const controlBorderHover = useColorModeValue('#CBD5E0', '#718096');
   const focusBoxShadow = useColorModeValue('0 0 0 1px #3182CE', '0 0 0 1px #63B3ED');
   const placeholderColor = useColorModeValue('#A0AEC0', '#718096');
   const optionBg = useColorModeValue('#FFFFFF', '#2D3748');
   const optionHoverBg = useColorModeValue('#EDF2F7', '#4A5568');
   const menuBg = useColorModeValue('#FFFFFF', '#2D3748');
   const menuBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const indicatorColor = useColorModeValue('#718096', '#A0AEC0');
   const indicatorHoverColor = useColorModeValue('#4A5568', '#CBD5E0');
   const company = useSelector((state) => state.company.list || []);
   // const [fromDate, setFromDate] = useState(null);
   // const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
   const accounts = useSelector((state) => state.account.list || []);
   const [companyFilter, setCompanyFilter] = useState([]);
   const [reportType, setReportType] = useState('Profit & Loss Monthly');
   const [expandedItems, setExpandedItems] = useState({});
   const [sorting, setSorting] = useState([]);
   const [columnVisibility, setColumnVisibility] = useState({});
   const [isColumnSelectorOpen, setIsColumnSelectorOpen] = useState(false);
   const dbName = localStorage.getItem('dbName');
   const [searchQuery, setSearchQuery] = useState('');
   const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const companyBg = useColorModeValue('#F1F0E8', '#16213E');
   const searchTimeoutRef = useRef(null);
   const [isLoading, setIsLoading] = useState(false);
   const ProfitLossMonthly = useSelector((state) => state.reports?.ProfitLossMonthly || []);
   const { userGlobalSettingsData } = useGlobal();
   const globalSettingAcc = userGlobalSettingsData?.[0]?.askCompany?.account;
   const shouldShowCompanyDropdownAcc = globalSettingAcc || false;
   const [dateRange, setDateRange] = useState(() => {
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 6);

      return {
         fromDate: sevenDaysAgo.toISOString().split('T')[0], // last 7th day
         toDate: today.toISOString().split('T')[0], // today
      };
   });
   const reportTypeOptions = [
      { value: 'Profit & Loss Monthly', label: 'Profit & Loss Monthly' },
      { value: 'Profit & Loss T Format', label: 'Profit & Loss T Format' },
      { value: 'Profit & Loss Vertical', label: 'Profit & Loss Vertical' },
   ];

   const handleCompanyChange = (selectedOptions) => {
      setCompanyFilter(selectedOptions ? selectedOptions : []);
   };

   const dispatch = useDispatch();
   const fromDateInputRef = useRef(null);

   // Initialize column visibility for Balance Sheet columns
   useEffect(() => {
      const initialColumnVisibility = {
         accountName: true,
         debit: true,
         credit: true,
      };
      setColumnVisibility(initialColumnVisibility);
   }, []);

   const columns = useMemo(() => {
      return [];
   }, [columnHelper, textColor]);

   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
   const companyIds = useMemo(
      () =>
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
            ? [parseInt(localStorage.getItem('companyId'))]
            : [],
      [companyFilter],
   );

   const { isOpen, onOpen, onClose } = useDisclosure();
   const [datePartyWiseSalesRange, setPartyWiseSalesDateRange] = useState('');

   const table = useReactTable({
      data: ProfitLossMonthly,
      columns,
      state: {
         sorting,
         columnVisibility,
      },
      onSortingChange: setSorting,
      onColumnVisibilityChange: setColumnVisibility,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   const [fromDate, setFromDate] = useState(() => {
      const today = new Date();
      today.setFullYear(today.getFullYear() - 1);
      return today.toISOString().split('T')[0];
   });
   const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);

   const { companyList } = useGlobal();

   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   useEffect(() => {
      const storedCompanyId = localStorage.getItem('companyId');
      if (storedCompanyId && companyList.length > 0) {
         const companyId = parseInt(storedCompanyId);
         const matchingCompany = companyList.find((comp) => comp.id === companyId);
         if (matchingCompany) {
            setCompanyFilter([matchingCompany.id]);
         }
      }
   }, [companyList]);

   useEffect(() => {
      const fetchData = async () => {
         setIsLoading(true);

         // Get company IDs with validation
         const companyIds =
            companyFilter.length > 0
               ? companyFilter.filter((id) => !isNaN(Number(id)) && Number(id) > 0) // Filter out invalid IDs
               : localStorage.getItem('companyId') &&
                 !isNaN(Number(localStorage.getItem('companyId'))) &&
                 Number(localStorage.getItem('companyId')) > 0
               ? [parseInt(localStorage.getItem('companyId'), 10)]
               : [];

         // Validate all required parameters before making API call
         const hasValidCompanyIds =
            Array.isArray(companyIds) &&
            companyIds.length > 0 &&
            !companyIds.some((id) => isNaN(Number(id)) || Number(id) <= 0);
         const hasValidDateRange = datePartyWiseSalesRange && fromDate && toDate;

         if (hasValidCompanyIds && hasValidDateRange) {
            try {
               if (reportType === 'Profit & Loss T Format') {
                  await dispatch(
                     getProfitLossMonthly({
                        companyIds: companyIds.join(','),
                        fromDate: datePartyWiseSalesRange.fromDate,
                        toDate: datePartyWiseSalesRange.toDate,
                        search: debouncedSearchQuery,
                     }),
                  );
               } else if (reportType === 'Profit & Loss Monthly') {
                  await dispatch(
                     getProfitLossMonthly({
                        companyIds: companyIds.join(','),
                        fromDate: datePartyWiseSalesRange.fromDate,
                        toDate: datePartyWiseSalesRange.toDate,
                        search: debouncedSearchQuery,
                     }),
                  );
               } else {
                  await dispatch(
                     getProfitLossMonthly({
                        companyIds: companyIds.join(','),
                        fromDate: datePartyWiseSalesRange.fromDate,
                        toDate: datePartyWiseSalesRange.toDate,
                        search: debouncedSearchQuery,
                     }),
                  );
               }
            } catch (error) {
               console.error('Error fetching data:', error);
            } finally {
               setIsLoading(false);
            }
         } else {
            // If conditions aren't met, still set loading to false
            setIsLoading(false);

            // Optional: Log why the API call was skipped
            if (!hasValidCompanyIds) {
               console.log('Skipping API call: Invalid or missing company IDs');
            }
            if (!hasValidDateRange) {
               console.log('Skipping API call: Invalid or missing date range');
            }
         }
      };

      fetchData();
   }, [dispatch, companyFilter, fromDate, toDate, reportType, debouncedSearchQuery, datePartyWiseSalesRange]);

   const handleRefresh = async () => {
      setIsLoading(true);
      const companyIds =
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
            ? [parseInt(localStorage.getItem('companyId'))]
            : [];

      try {
         if (fromDate && toDate && companyIds.length > 0 && !companyIds.some(isNaN)) {
            if (reportType === 'Profit & Loss T Format') {
               await dispatch(
                  getProfitLossMonthly({
                     companyIds: companyIds.join(','),
                     fromDate,
                     toDate,
                     search: debouncedSearchQuery,
                  }),
               );
            } else if (reportType === 'Profit & Loss Monthly') {
               await dispatch(
                  getProfitLossMonthly({
                     companyIds: companyIds.join(','),
                     fromDate: fromDate,
                     toDate: toDate,
                     search: debouncedSearchQuery,
                  }),
               );
            } else {
               await dispatch(
                  getProfitLossMonthly({
                     companyIds: companyIds.join(','),
                     fromDate,
                     toDate,
                     search: debouncedSearchQuery,
                  }),
               );
            }
         }
      } catch (error) {
         console.error('Refresh error:', error);
      } finally {
         setIsLoading(false);
      }
   };

   const handleDateRangeChange = (dates) => {
      if (!dates || dates.length !== 2) return;

      const [from, to] = dates.map((date) => (typeof date === 'string' ? date : date.toISOString().slice(0, 10)));

      setPartyWiseSalesDateRange({ fromDate: from, toDate: to });
   };

   const handleSearchChange = (e) => {
      const value = e.target.value;
      setSearchQuery(value); // Update UI immediately

      // Clear previous timeout
      if (searchTimeoutRef.current) {
         clearTimeout(searchTimeoutRef.current);
      }

      // Set new timeout (500ms after typing stops)
      searchTimeoutRef.current = setTimeout(() => {
         performSearch(value);
      }, 500);
   };

   useEffect(() => {
      const handler = setTimeout(() => {
         setDebouncedSearchQuery(searchQuery);
      }, 500);

      return () => {
         clearTimeout(handler);
      };
   }, [searchQuery]);

   const [expanded, setExpanded] = useState(false);
   const wrapperRef = useRef();
   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   const performSearch = async (query) => {
      if (isLoading) return;

      setIsLoading(true);
      const companyIds =
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
            ? [parseInt(localStorage.getItem('companyId'))]
            : [];

      try {
         await dispatch(
            getProfitLossMonthly({
               companyIds: companyIds.join(','),
               fromDate: datePartyWiseSalesRange?.fromDate || fromDate,
               toDate: datePartyWiseSalesRange?.toDate || toDate,
               search: query,
            }),
         );
      } catch (error) {
         console.error('Search error:', error);
      } finally {
         setIsLoading(false);
      }
   };

   useEffect(() => {
      return () => {
         if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
         }
      };
   }, []);

   const lastcompanyOptions = companyOptions.map((company) => ({
      value: company.value,
      label: company.label,
      id: company.value,
      name: company.label,
   }));

   useEffect(() => {
      const handleKeyDown = (e) => {
         const isTargetInput =
            e.target.tagName === 'INPUT' ||
            e.target.tagName === 'TEXTAREA' ||
            e.target.tagName === 'SELECT' ||
            e.target.isContentEditable;

         if (e.key.toLowerCase() === 't' && !isTargetInput) {
            if (fromDateInputRef.current) {
               fromDateInputRef.current.focus();
            }
         }
      };

      document.addEventListener('keydown', handleKeyDown);
      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, []);

   const downloadExcel = () => {
      if (reportType === 'Profit & Loss Monthly') {
         const allMonths = Array.from(
            new Set(
               ProfitLossMonthly.flatMap((company) =>
                  company.data.flatMap((group) => (group.monthData ? Object.keys(group.monthData) : [])),
               ),
            ),
         ).sort((a, b) => {
            const monthsOrder = ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];
            const monthA = a.split('-')[0];
            const monthB = b.split('-')[0];
            return monthsOrder.indexOf(monthA) - monthsOrder.indexOf(monthB);
         });

         const colors = {
            companyHeader: 'F8FAFC', // Light blue for company headers (matches UI)
            itemHeader: 'F8FAFC', // Light gray for item headers
            oddRow: 'FFFFFF', // White for odd rows
            evenRow: 'F5F5F5', // Light gray for even rows
            totalRow: 'E6FFED', // Light green for totals
            headerText: '000000', // Black for header text
         };

         const headers = ['Account', ...allMonths];
         const finalData = [];
         const styles = [];

         ProfitLossMonthly.forEach((ProfitLossdata) => {
            // finalData.push([`${ProfitLossdata.companyName}`]);
            const companyNameRow = Array(headers.length).fill('');
            companyNameRow[0] = ProfitLossdata.companyName;
            finalData.push(companyNameRow);
            styles.push(
               Array(headers.length).fill({
                  font: { bold: true, sz: 14, color: { rgb: colors.headerText } },
                  fill: { patternType: 'solid', fgColor: { rgb: 'F8FAFC' } },
                  alignment: { horizontal: 'left' },
               }),
            );

            finalData.push(headers);
            styles.push(
               Array(headers.length).fill({
                  font: { bold: true, sz: 12, color: { rgb: colors.headerText } },
               }),
            );

            ProfitLossdata.data.forEach((group) => {
               finalData.push([group.type]);
               styles.push(
                  Array(headers.length).fill({
                     font: { bold: true, sz: 10, color: { rgb: colors.headerText } },
                  }),
               );

               group.data.forEach((groupdata) => {
                  const row = [];
                  const rowStyle = [];
                  row.push(groupdata.accountName || '');

                  allMonths.forEach((month) => {
                     const value = group.monthData?.[month] ?? 0;
                     row.push(value);
                  });

                  finalData.push(row);
                  styles.push(rowStyle);
               });

               finalData.push([]);
               styles.push([]);
            });

            finalData.push([]);
            styles.push([]);
         });

         // Create worksheet and workbook
         const ws = XLSX.utils.aoa_to_sheet(finalData);

         // Set column widths
         ws['!cols'] = [
            { width: 40 }, // Account Name
            ...allMonths.map(() => ({ width: 15 })),
         ];

         // Apply styles to each cell
         styles.forEach((rowStyles, rowNum) => {
            rowStyles.forEach((style, colNum) => {
               if (style) {
                  const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
                  if (!ws[cellAddress]) ws[cellAddress] = {};
                  ws[cellAddress].s = style;
               }
            });
         });

         const wb = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws, 'Profit & Loss Monthly');
         XLSX.writeFile(wb, 'ProfitLossMonthly.xlsx');
      }
      if (reportType === 'Profit & Loss T Format') {
         const colors = {
            companyHeader: 'F8FAFC', // Light blue for company headers (matches UI)
            itemHeader: 'F8FAFC', // Light gray for item headers
            oddRow: 'FFFFFF', // White for odd rows
            evenRow: 'F5F5F5', // Light gray for even rows
            totalRow: 'E6FFED', // Light green for totals
            headerText: '000000', // Black for header text
         };

         const categorizeProfitLossItems = (data) => {
            const debitItems = [];
            const creditItems = [];

            data.forEach((group) => {
               // Determine if this group belongs to debit or credit side
               const isDebitSide = [
                  'EXPENSES',
                  'COST OF GOODS SOLD',
                  'OPERATING EXPENSES',
                  'PURCHASES',
                  'DIRECT EXPENSES',
                  'INDIRECT EXPENSES',
                  'PURCHASE',
                  'JOB CHARGE',
                  'PACKAGING EXPENSES',
               ].some((type) => group.type.toUpperCase().includes(type.toUpperCase()));

               // Add individual items from this group
               group.data.forEach((item) => {
                  const itemData = {
                     account: item.accountName,
                     amount: Math.abs(Number(item.total || 0)),
                  };

                  if (isDebitSide) {
                     debitItems.push(itemData);
                  } else {
                     creditItems.push(itemData);
                  }
               });
            });

            return { debitItems, creditItems };
         };

         // Get the profit & loss data from the first company
         const ProfitLossData = ProfitLossMonthly[0].data;
         const { debitItems, creditItems } = categorizeProfitLossItems(ProfitLossData);

         // Calculate totals
         const totalDebits = debitItems.reduce((sum, item) => sum + Number(item.amount || 0), 0);
         const totalCredits = creditItems.reduce((sum, item) => sum + Number(item.amount || 0), 0);

         // Calculate profit/loss
         const profitLoss = totalCredits - totalDebits;
         const isProfitable = profitLoss > 0;

         // Balance the sides by adding profit/loss
         let finalDebitItems = [...debitItems];
         let finalCreditItems = [...creditItems];
         let finalAllData = [
            {
               debit: finalDebitItems,
               credit: finalCreditItems,
            },
         ];

         if (isProfitable) {
            finalDebitItems.push({
               account: 'NET PROFIT',
               amount: profitLoss,
               isTotal: true,
            });
         } else if (profitLoss < 0) {
            finalCreditItems.push({
               account: 'NET LOSS',
               amount: Math.abs(profitLoss),
               isTotal: true,
            });
         }

         // Calculate final totals
         const finalDebitTotal = totalDebits + (isProfitable ? profitLoss : 0);
         const finalCreditTotal = totalCredits + (!isProfitable ? Math.abs(profitLoss) : 0);

         // Determine the maximum number of rows to iterate
         const maxRows = Math.max(finalDebitItems.length, finalCreditItems.length);

         const headers = ['Particulars', 'Amount', '', 'Particulars', 'Amount'];
         const finalData = [];
         const styles = [];

         finalAllData.forEach((data) => {
            finalData.push(headers);
            styles.push(
               Array(headers.length).fill({
                  font: { bold: true, sz: 12, color: { rgb: colors.headerText } },
               }),
            );
            let count = 0;

            while (count < maxRows) {
               finalData.push([
                  data?.debit?.[count]?.account || '',
                  data?.debit?.[count]?.amount || '',
                  '',
                  data?.credit?.[count]?.account || '',
                  data?.credit?.[count]?.amount || '',
               ]);

               styles.push(
                  Array(headers.length).fill({
                     font: { sz: 12, color: { rgb: colors.headerText } },
                  }),
               );

               count++;
            }

            finalData.push(['Total', finalDebitTotal, '', 'Total', finalCreditTotal]);
            styles.push(
               Array(headers.length).fill({
                  font: { bold: true, sz: 14, color: { rgb: colors.headerText } },
                  fill: { patternType: 'solid', fgColor: { rgb: 'F8FAFC' } },
               }),
            );
         });

         // Create worksheet and workbook
         const ws = XLSX.utils.aoa_to_sheet(finalData);

         // Set column widths
         ws['!cols'] = [{ width: 40 }, { width: 20 }, { width: 1 }, { width: 40 }, { width: 20 }];

         // Apply styles to each cell
         styles.forEach((rowStyles, rowNum) => {
            rowStyles.forEach((style, colNum) => {
               if (style) {
                  const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
                  if (!ws[cellAddress]) ws[cellAddress] = {};
                  ws[cellAddress].s = style;
               }
            });
         });

         const wb = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws, 'Profit & Loss Monthly');
         XLSX.writeFile(wb, 'ProfitLossMonthly.xlsx');
      }
      if (reportType === 'Profit & Loss Vertical') {
         const formatCurrency = (value) => {
            if (value === null || value === undefined) return '-';
            const numValue = Number(value);
            if (isNaN(numValue)) return value;

            // Format with Indian numbering system (lakhs, crores)
            return new Intl.NumberFormat('en-IN', {
               maximumFractionDigits: 2,
            }).format(Math.abs(numValue));
         };

         const companyData = ProfitLossMonthly[0].data;

         // Create rows for rendering in the desired format
         const createRows = () => {
            const rows = [];

            // First group data by category
            const categories = {};
            companyData.forEach((group) => {
               if (!categories[group.type]) {
                  categories[group.type] = [];
               }
               categories[group.type].push(...group.data);
            });

            // Process each category
            Object.entries(categories).forEach(([category, items]) => {
               // Skip empty categories
               if (items.length === 0) return;

               // Add category header
               rows.push({
                  type: 'group',
                  account: category,
                  amount: '',
                  company: '',
               });

               // Add all items under this category
               items.forEach((item) => {
                  rows.push({
                     type: 'item',
                     account: item.accountName,
                     amount: formatCurrency(item.total),
                     company: companyData.companyName,
                  });
               });

               // Calculate category total
               const categoryTotal = items.reduce((sum, item) => sum + Math.abs(Number(item.total)), 0);

               // Add category total
               rows.push({
                  type: 'subtotal',
                  account: `Total`,
                  amount: formatCurrency(categoryTotal),
               });

               // Add empty row for spacing
               rows.push({
                  type: 'spacer',
                  account: '',
                  amount: '',
               });
            });

            return rows;
         };

         const rows = createRows();

         const getRowStyle = (type) => {
            switch (type) {
               case 'group':
                  return {
                     font: { bold: true, sz: 14, color: { rgb: colors.headerText } },
                     fill: { patternType: 'solid', fgColor: { rgb: 'F1F5F9' } }, // light gray background
                  };
               case 'subtotal':
                  return {
                     font: { bold: true, sz: 12 },
                     border: {
                        top: { style: 'thin', color: { rgb: 'CCCCCC' } },
                        bottom: { style: 'thin', color: { rgb: 'CCCCCC' } },
                     },
                  };
               case 'spacer':
                  return {}; // Excel doesn't support row height via styles here
               default:
                  return {
                     font: { sz: 12, color: { rgb: colors.headerText } },
                  };
            }
         };

         const colors = {
            companyHeader: 'F8FAFC', // Light blue for company headers (matches UI)
            itemHeader: 'F8FAFC', // Light gray for item headers
            oddRow: 'FFFFFF', // White for odd rows
            evenRow: 'F5F5F5', // Light gray for even rows
            totalRow: 'E6FFED', // Light green for totals
            headerText: '000000', // Black for header text
         };

         const headers = ['Account', 'Amount'];
         const finalData = [];
         const styles = [];

         finalData.push(headers);
         styles.push(
            Array(headers.length).fill({
               font: { bold: true, sz: 12, color: { rgb: colors.headerText } },
            }),
         );
         rows.forEach((data) => {
            finalData.push([data?.account, data?.amount]);
            const rowStyle = getRowStyle(data.type);
            styles.push(Array(headers.length).fill(rowStyle));
         });

         finalData.push([]);
         styles.push([]);

         // Create worksheet and workbook
         const ws = XLSX.utils.aoa_to_sheet(finalData);

         // Set column widths
         ws['!cols'] = [
            { width: 40 }, // Account Name
         ];

         // Apply styles to each cell
         styles.forEach((rowStyles, rowNum) => {
            rowStyles.forEach((style, colNum) => {
               if (style) {
                  const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
                  if (!ws[cellAddress]) ws[cellAddress] = {};
                  ws[cellAddress].s = style;
               }
            });
         });

         const wb = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws, 'Profit & Loss Monthly');
         XLSX.writeFile(wb, 'ProfitLossMonthly.xlsx');
      }
   };

   const downloadPDF = () => {
      const doc = new jsPDF({
         orientation: reportType === 'Profit & Loss T Format' ? 'landscape' : 'portrait',
         unit: 'mm',
         format: 'a4',
      });

      // Set document properties
      doc.setProperties({
         title: 'Profit & Loss Report',
         subject: reportType,
         author: 'Your App Name',
         keywords: 'profit, loss, financial, report',
         creator: 'Your App Name',
      });

      // Frontend color mapping
      const colors = {
         white: [255, 255, 255],
         companyBg: [230, 239, 252], // rgba(0, 63, 140, 0.1)
         evenRowBg: [255, 255, 255],
         oddRowBg: [240, 248, 255], // rgba(0, 63, 140, 0.05)
         tableHeaderBg: [245, 245, 245], // #F5F5F5
         groupHeaderBg: [230, 245, 255], // rgba(0, 63, 140, 0.15)
         tFormatHeaderBg: [230, 245, 255],
         textColor: [33, 37, 41],
         borderColor: [206, 212, 218],
         profitColor: [46, 125, 50],
         lossColor: [211, 47, 47],
         profitBg: [230, 255, 237],
         lossBg: [255, 235, 238],
      };

      // Format currency exactly like frontend
      const formatCurrency = (value) => {
         if (value === null || value === undefined) return '-';
         const numValue = Number(value);
         if (isNaN(numValue)) return value;
         return new Intl.NumberFormat('en-IN', {
            maximumFractionDigits: 2,
         }).format(Math.abs(numValue));
      };

      // Add header
      const addHeader = () => {
         doc.setFontSize(14);
         doc.setFont('helvetica', 'bold');
         doc.setTextColor(...colors.textColor);
         doc.text(reportType, doc.internal.pageSize.width / 2, 15, { align: 'center' });

         doc.setFontSize(10);
         doc.setFont('helvetica', 'normal');
         doc.text(
            `Date Range: ${datePartyWiseSalesRange?.fromDate || fromDate} to ${
               datePartyWiseSalesRange?.toDate || toDate
            }`,
            doc.internal.pageSize.width / 2,
            20,
            { align: 'center' },
         );
      };

      addHeader();

      if (reportType === 'Profit & Loss Monthly') {
         let startY = 25;
         const pageWidth = doc.internal.pageSize.width;
         const margin = 10;
         const contentWidth = pageWidth - margin * 2;

         ProfitLossMonthly.forEach((company, companyIndex) => {
            // Company header with frontend styling
            doc.setFillColor(...colors.companyBg);
            doc.rect(margin, startY - 3, contentWidth, 8, 'F');

            doc.setFontSize(8);
            doc.setTextColor(...colors.textColor);
            doc.setFont('helvetica', 'bold');
            doc.text(company.companyName, margin + 3, startY + 2);
            startY += 7;

            // Get all months like frontend
            const allMonths = Array.from(
               new Set(company.data.flatMap((group) => (group.monthData ? Object.keys(group.monthData) : []))),
            ).sort((a, b) => {
               const monthsOrder = ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];
               const monthA = a.split('-')[0];
               const monthB = b.split('-')[0];
               return monthsOrder.indexOf(monthA) - monthsOrder.indexOf(monthB);
            });

            // Calculate column widths
            const accountColWidth = 60;
            const monthColWidth = allMonths.length > 0 ? (contentWidth - accountColWidth) / allMonths.length : 30;

            // Draw table header
            doc.setFillColor(...colors.tableHeaderBg);
            doc.rect(margin, startY, contentWidth, 8, 'F');

            doc.setFontSize(8);
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(...colors.textColor);

            // Account header
            doc.text('Account', margin + 2, startY + 5);

            // Month headers
            allMonths.forEach((month, index) => {
               const x = margin + accountColWidth + index * monthColWidth;
               doc.text(month, x + 2, startY + 5);
            });

            startY += 10;

            // Draw data exactly like frontend structure
            company.data.forEach((group, groupIndex) => {
               // Group header row - matches frontend styling
               doc.setFillColor(...colors.groupHeaderBg);
               doc.rect(margin, startY, contentWidth, 7, 'F');
               doc.setFontSize(8);
               doc.setFont('helvetica', 'bold');
               doc.setTextColor(...colors.textColor);
               doc.text(group.type, margin + 2, startY + 4);
               startY += 8;

               // Group items
               group.data.forEach((item, itemIndex) => {
                  // Alternate row colors like frontend
                  if (itemIndex % 2 === 1) {
                     doc.setFillColor(...colors.oddRowBg);
                     doc.rect(margin, startY, contentWidth, 6, 'F');
                  }

                  doc.setFontSize(8);
                  doc.setFont('helvetica', 'normal');
                  doc.setTextColor(...colors.textColor);

                  // Account name (indented like frontend)
                  doc.text(item.accountName || '-', margin + 8, startY + 4);

                  // Month values
                  allMonths.forEach((month, monthIndex) => {
                     const monthValue = group.monthData && group.monthData[month] ? Number(group.monthData[month]) : 0;
                     const x = margin + accountColWidth + monthIndex * monthColWidth;
                     doc.text(formatCurrency(monthValue), x + monthColWidth - 2, startY + 4, { align: 'right' });
                  });

                  startY += 6;
               });

               // Add spacing between groups like frontend
               startY += 3;

               // Check page break
               if (startY > 250) {
                  doc.addPage();
                  addHeader();
                  startY = 35;
               }
            });

            startY += 10; // Space between companies
         });
      } else if (reportType === 'Profit & Loss Vertical') {
         const companyData = ProfitLossMonthly[0]?.data || [];
         let startY = 25;
         const pageWidth = doc.internal.pageSize.width;
         const margin = 15;
         const contentWidth = pageWidth - margin * 2;

         // Group data exactly like frontend
         const categories = {};
         companyData.forEach((group) => {
            if (!categories[group.type]) {
               categories[group.type] = [];
            }
            categories[group.type].push(...group.data);
         });

         Object.entries(categories).forEach(([category, items]) => {
            if (items.length === 0) return;

            // Category header - matches frontend group styling
            doc.setFillColor(...colors.groupHeaderBg);
            doc.rect(margin, startY - 2, contentWidth, 8, 'F');

            doc.setFontSize(8);
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(...colors.textColor);
            doc.text(category.toUpperCase(), margin + 5, startY + 3);
            startY += 10;

            // Category items
            items.forEach((item, index) => {
               // Alternate row colors like frontend
               if (index % 2 === 1) {
                  doc.setFillColor(...colors.oddRowBg);
                  doc.rect(margin, startY, contentWidth, 6, 'F');
               }

               doc.setFontSize(8);
               doc.setFont('helvetica', 'normal');
               doc.setTextColor(...colors.textColor);

               // Account name
               doc.text(item.accountName, margin + 5, startY + 4);

               // Amount (right aligned)
               doc.text(formatCurrency(item.total), pageWidth - margin - 5, startY + 4, { align: 'right' });

               startY += 6;
            });

            // Category total with frontend subtotal styling
            const categoryTotal = items.reduce((sum, item) => sum + Math.abs(Number(item.total || 0)), 0);

            doc.setDrawColor(...colors.borderColor);
            doc.line(margin, startY, pageWidth - margin, startY); // Top border
            doc.line(margin, startY + 6, pageWidth - margin, startY + 6); // Bottom border

            doc.setFontSize(8);
            doc.setFont('helvetica', 'bold');
            doc.text('Total', margin + 5, startY + 4);
            doc.text(formatCurrency(categoryTotal), pageWidth - margin - 5, startY + 4, { align: 'right' });

            startY += 12; // Extra spacing after category

            // Check page break
            if (startY > 250) {
               doc.addPage();
               addHeader();
               startY = 35;
            }
         });
      } else if (reportType === 'Profit & Loss T Format') {
         const companyData = ProfitLossMonthly[0]?.data || [];

         // Categorize items exactly like frontend
         const categorizeItems = (data) => {
            const debitItems = [];
            const creditItems = [];

            data.forEach((group) => {
               const isDebitSide = [
                  'EXPENSES',
                  'COST OF GOODS SOLD',
                  'OPERATING EXPENSES',
                  'PURCHASES',
                  'DIRECT EXPENSES',
                  'INDIRECT EXPENSES',
                  'PURCHASE',
                  'JOB CHARGE',
                  'PACKAGING EXPENSES',
               ].some((type) => group.type.toUpperCase().includes(type.toUpperCase()));

               group.data.forEach((item) => {
                  const itemData = {
                     account: item.accountName,
                     amount: Math.abs(Number(item.total || 0)),
                  };

                  if (isDebitSide) {
                     debitItems.push(itemData);
                  } else {
                     creditItems.push(itemData);
                  }
               });
            });

            return { debitItems, creditItems };
         };

         const { debitItems, creditItems } = categorizeItems(companyData);
         const totalDebits = debitItems.reduce((sum, item) => sum + item.amount, 0);
         const totalCredits = creditItems.reduce((sum, item) => sum + item.amount, 0);
         const profitLoss = totalCredits - totalDebits;
         const isProfitable = profitLoss > 0;

         // Balance sides like frontend
         let finalDebitItems = [...debitItems];
         let finalCreditItems = [...creditItems];

         if (isProfitable) {
            finalDebitItems.push({ account: 'NET PROFIT', amount: profitLoss, isTotal: true });
         } else if (profitLoss < 0) {
            finalCreditItems.push({ account: 'NET LOSS', amount: Math.abs(profitLoss), isTotal: true });
         }

         const pageWidth = doc.internal.pageSize.width;
         const margin = 10;
         const colWidth = (pageWidth - margin * 2 - 8) / 4; // 4 columns with spacer
         let startY = 35;

         // T-Format header
         doc.setFillColor(...colors.tFormatHeaderBg);
         doc.rect(margin, startY, pageWidth - margin * 2, 8, 'F');

         doc.setFontSize(8);
         doc.setFont('helvetica', 'bold');
         doc.setTextColor(...colors.textColor);

         // Header labels
         doc.text('Particulars', margin + 5, startY + 5);
         doc.text('Amount', margin + colWidth - 5, startY + 5, { align: 'right' });
         doc.text('Particulars', margin + colWidth * 2 + 8 + 5, startY + 5);
         doc.text('Amount', margin + colWidth * 4 + 8 - 5, startY + 5, { align: 'right' });

         startY += 12;

         // T-Format data rows
         const maxRows = Math.max(finalDebitItems.length, finalCreditItems.length);

         for (let i = 0; i < maxRows; i++) {
            const debitItem = finalDebitItems[i];
            const creditItem = finalCreditItems[i];

            // Row background for alternating colors
            if (i % 2 === 1 && !debitItem?.isTotal && !creditItem?.isTotal) {
               doc.setFillColor(...colors.oddRowBg);
               doc.rect(margin, startY, pageWidth - margin * 2, 6, 'F');
            }

            // Special styling for net result
            if (debitItem?.isTotal || creditItem?.isTotal) {
               const bgColor = isProfitable ? colors.profitBg : colors.lossBg;
               doc.setFillColor(...bgColor);
               doc.rect(margin, startY, pageWidth - margin * 2, 6, 'F');
            }

            doc.setFontSize(8);
            doc.setFont('helvetica', debitItem?.isTotal || creditItem?.isTotal ? 'bold' : 'normal');

            let textColor = colors.textColor;
            if (debitItem?.isTotal || creditItem?.isTotal) {
               textColor = isProfitable ? colors.profitColor : colors.lossColor;
            }
            doc.setTextColor(...textColor);

            // Debit side
            if (debitItem) {
               doc.text(debitItem.account, margin + 2, startY + 4);
               doc.text(formatCurrency(debitItem.amount), margin + colWidth - 2, startY + 4, { align: 'right' });
            }

            // Credit side
            if (creditItem) {
               doc.text(creditItem.account, margin + colWidth * 2 + 8 + 2, startY + 4);
               doc.text(formatCurrency(creditItem.amount), margin + colWidth * 4 + 8 - 2, startY + 4, {
                  align: 'right',
               });
            }

            startY += 6;
         }

         // Total row
         doc.setDrawColor(...colors.borderColor);
         doc.line(margin, startY, pageWidth - margin, startY);

         doc.setFillColor(...colors.borderColor);
         doc.rect(margin, startY + 1, pageWidth - margin * 2, 7, 'F');

         doc.setFontSize(8);
         doc.setFont('helvetica', 'bold');
         doc.setTextColor(...colors.textColor);

         const finalDebitTotal = totalDebits + (isProfitable ? profitLoss : 0);
         const finalCreditTotal = totalCredits + (!isProfitable ? Math.abs(profitLoss) : 0);

         doc.text('TOTAL', margin + 2, startY + 5);
         doc.text(formatCurrency(finalDebitTotal), margin + colWidth - 2, startY + 5, { align: 'right' });
         doc.text('TOTAL', margin + colWidth * 2 + 8 + 2, startY + 5);
         doc.text(formatCurrency(finalCreditTotal), margin + colWidth * 4 + 8 - 2, startY + 5, { align: 'right' });
      }

      // Footer
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
         doc.setPage(i);
         doc.setFontSize(8);
         doc.setTextColor(...colors.textColor);
         doc.text(
            `Generated: ${new Date().toLocaleDateString('en-IN')} | Page ${i} of ${pageCount}`,
            doc.internal.pageSize.width / 2,
            doc.internal.pageSize.height - 10,
            { align: 'center' },
         );
      }

      doc.save(`${reportType.replace(/ /g, '_')}_Report.pdf`);
   };

   const ColumnVisibilityModal = () => (
      <Modal isOpen={isColumnSelectorOpen} onClose={() => setIsColumnSelectorOpen(false)} size="md">
         <ModalOverlay />
         <ModalContent>
            <ModalHeader>Show/Hide Columns</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
               {columns.map((column) => (
                  <Flex key={column.id} mb={2} alignItems="center">
                     <Checkbox
                        isChecked={!!columnVisibility[column.id]}
                        onChange={(e) => {
                           table.setColumnVisibility((prev) => ({
                              ...prev,
                              [column.id]: e.target.checked,
                           }));
                        }}
                        mr={2}
                     />
                     <Text>{column.header}</Text>
                  </Flex>
               ))}
            </ModalBody>
            <ModalFooter>
               <Button colorScheme="blue" onClick={() => setIsColumnSelectorOpen(false)}>
                  Close
               </Button>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );

   const renderVerticalFormatProfitLossMonthly = () => {
      // Check if data exists
      if (
         !ProfitLossMonthly ||
         ProfitLossMonthly.length === 0 ||
         !ProfitLossMonthly[0]?.data ||
         ProfitLossMonthly[0].data.length === 0
      ) {
         return (
            <>
               <Tr justifyContent="center" alignItems="center" width="100%" height="100%">
                  <Td
                     p="2px"
                     py="3px"
                     fontSize="10px"
                     whiteSpace="nowrap"
                     textOverflow="ellipsis"
                     maxW="150px"
                     overflow="hidden"
                     colSpan={2}
                     justifyContent="center"
                     alignItems="center"
                     width="100%">
                     <Grid justifyContent="center" alignItems="center" gap={9}>
                        <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                        <GridItem justifySelf="center">
                           <label>No profit and loss data found</label>
                        </GridItem>
                     </Grid>
                  </Td>
               </Tr>
            </>
         );
      }

      // Helper function to format currency (modified to match your screenshot format)
      const formatCurrency = (value) => {
         if (value === null || value === undefined) return '-';
         const numValue = Number(value);
         if (isNaN(numValue)) return value;

         // Format with Indian numbering system (lakhs, crores)
         return new Intl.NumberFormat('en-IN', {
            maximumFractionDigits: 2,
         }).format(Math.abs(numValue));
      };

      // Extract the company data
      const companyData = ProfitLossMonthly[0].data;

      // Create rows for rendering in the desired format
      const createRows = () => {
         const rows = [];

         // First group data by category
         const categories = {};
         companyData.forEach((group) => {
            if (!categories[group.type]) {
               categories[group.type] = [];
            }
            categories[group.type].push(...group.data);
         });

         // Process each category
         Object.entries(categories).forEach(([category, items]) => {
            // Skip empty categories
            if (items.length === 0) return;

            // Add category header
            rows.push({
               type: 'group',
               account: category,
               amount: '',
               company: '',
            });

            // Add all items under this category
            items.forEach((item) => {
               rows.push({
                  type: 'item',
                  account: item.accountName,
                  amount: formatCurrency(item.total),
                  company: companyData.companyName,
               });
            });

            // Calculate category total
            const categoryTotal = items.reduce((sum, item) => sum + Math.abs(Number(item.total)), 0);

            // Add category total
            rows.push({
               type: 'subtotal',
               account: `Total`,
               amount: formatCurrency(categoryTotal),
            });

            // Add empty row for spacing
            rows.push({
               type: 'spacer',
               account: '',
               amount: '',
            });
         });

         return rows;
      };

      const rows = createRows();

      // Get styling based on row type
      const getRowStyle = (type) => {
         switch (type) {
            case 'group':
               return {
                  fontWeight: 'bold',
                  fontSize: '16px',
                  bg: companyBg,
                  textTransform: 'uppercase',
               };
            case 'subtotal':
               return {
                  fontWeight: 'bold',
                  borderTop: '1px solid',
                  borderBottom: '1px solid',
                  borderColor: 'gray.200',
               };
            case 'spacer':
               return {
                  height: '10px',
               };
            default:
               return {};
         }
      };

      return (
         <>
            <>
               {rows.map((row, index) => (
                  <Tr
                     key={`row-${index}`}
                     bg={row.type === 'item' && index % 2 === 0 ? 'white' : 'transparent'}
                     _dark={{ bg: row.type === 'item' && index % 2 === 0 ? '#101F4A' : 'transparent' }}>
                     {/* Account Name Column */}
                     <Td
                        p="2px"
                        fontSize={'14px'}
                        color={textColor}
                        borderColor={borderColor}
                        {...getRowStyle(row.type)}
                        fontWeight={row.type === 'item' ? 'normal' : 'bold'}>
                        {row.account}
                     </Td>

                     {/* Amount Column */}
                     <Td
                        p="2px"
                        fontSize={'14px'}
                        color={textColor}
                        borderColor={borderColor}
                        textAlign="right"
                        {...getRowStyle(row.type)}
                        fontWeight={row.type === 'item' ? 'normal' : 'bold'}>
                        {row.amount}
                     </Td>
                  </Tr>
               ))}
            </>
         </>
      );
   };

   const renderTFormatProfitLossMonthly = () => {
      if (!ProfitLossMonthly || ProfitLossMonthly.length === 0 || !ProfitLossMonthly[0]?.data) {
         return (
            <Tr justifyContent="center" alignItems="center" width="100%" height="100%">
               <Td
                  p="2px"
                  py="3px"
                  fontSize="10px"
                  whiteSpace="nowrap"
                  textOverflow="ellipsis"
                  maxW="150px"
                  overflow="hidden"
                  colSpan={4}
                  justifyContent="center"
                  alignItems="center"
                  width="100%">
                  <Grid justifyContent="center" alignItems="center" gap={9}>
                     <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                     <GridItem justifySelf="center">
                        <label>No profit and loss data found</label>
                     </GridItem>
                  </Grid>
               </Td>
            </Tr>
         );
      }

      // Format currency values helper function
      const formatCurrency = (value) => {
         if (value === null || value === undefined) return '-';
         const numValue = Number(value);
         if (isNaN(numValue)) return value;
         return new Intl.NumberFormat('en-IN', {
            maximumFractionDigits: 2,
         }).format(Math.abs(numValue));
      };

      // Extract and categorize profit & loss items from the data
      const categorizeProfitLossItems = (data) => {
         const debitItems = [];
         const creditItems = [];

         data.forEach((group) => {
            // Determine if this group belongs to debit or credit side
            const isDebitSide = [
               'EXPENSES',
               'COST OF GOODS SOLD',
               'OPERATING EXPENSES',
               'PURCHASES',
               'DIRECT EXPENSES',
               'INDIRECT EXPENSES',
               'PURCHASE',
               'JOB CHARGE',
               'PACKAGING EXPENSES',
            ].some((type) => group.type.toUpperCase().includes(type.toUpperCase()));

            // Add individual items from this group
            group.data.forEach((item) => {
               const itemData = {
                  account: item.accountName,
                  amount: Math.abs(Number(item.total || 0)),
               };

               if (isDebitSide) {
                  debitItems.push(itemData);
               } else {
                  creditItems.push(itemData);
               }
            });
         });

         return { debitItems, creditItems };
      };

      // Get the profit & loss data from the first company
      const ProfitLossData = ProfitLossMonthly[0].data;
      const { debitItems, creditItems } = categorizeProfitLossItems(ProfitLossData);

      // Calculate totals
      const totalDebits = debitItems.reduce((sum, item) => sum + Number(item.amount || 0), 0);
      const totalCredits = creditItems.reduce((sum, item) => sum + Number(item.amount || 0), 0);

      // Calculate profit/loss
      const profitLoss = totalCredits - totalDebits;
      const isProfitable = profitLoss > 0;

      // Balance the sides by adding profit/loss
      let finalDebitItems = [...debitItems];
      let finalCreditItems = [...creditItems];

      if (isProfitable) {
         finalDebitItems.push({
            account: 'NET PROFIT',
            amount: profitLoss,
            isTotal: true,
         });
      } else if (profitLoss < 0) {
         finalCreditItems.push({
            account: 'NET LOSS',
            amount: Math.abs(profitLoss),
            isTotal: true,
         });
      }

      // Calculate final totals
      const finalDebitTotal = totalDebits + (isProfitable ? profitLoss : 0);
      const finalCreditTotal = totalCredits + (!isProfitable ? Math.abs(profitLoss) : 0);

      // Determine the maximum number of rows to iterate
      const maxRows = Math.max(finalDebitItems.length, finalCreditItems.length);

      return (
         <>
            {/* Header Row */}
            <Tr bg="rgba(0, 63, 140, 0.1)" _dark={{ bg: 'rgba(2, 14, 56, 0.9)' }} fontWeight="bold">
               <Td p="12px" fontSize="16px" color={textColor} borderColor={borderColor} width="40%" fontWeight="bold">
                  Particulars
               </Td>
               <Td
                  p="12px"
                  fontSize="16px"
                  color={textColor}
                  borderColor={borderColor}
                  width="15%"
                  textAlign="right"
                  fontWeight="bold">
                  Amount
               </Td>
               <Td p="12px" fontSize="16px" color={textColor} borderColor={borderColor} width="40%" fontWeight="bold">
                  Particulars
               </Td>
               <Td
                  p="12px"
                  fontSize="16px"
                  color={textColor}
                  borderColor={borderColor}
                  width="15%"
                  textAlign="right"
                  fontWeight="bold">
                  Amount
               </Td>
            </Tr>

            {/* Profit & Loss Data Rows */}
            {Array.from({ length: maxRows }).map((_, index) => (
               <Tr
                  key={`summary-row-${index}`}
                  bg={index % 2 === 0 ? 'white' : 'rgba(0, 63, 140, 0.05)'}
                  _dark={{ bg: index % 2 === 0 ? '#101F4A' : 'rgba(2, 14, 56, 0.7)' }}>
                  {/* Debit Side - Account Name */}
                  <Td
                     p="8px"
                     fontSize={'14px'}
                     color={textColor}
                     borderColor={borderColor}
                     width="40%"
                     fontWeight={finalDebitItems[index]?.isTotal ? 'bold' : '500'}
                     textTransform={finalDebitItems[index]?.isTotal ? 'uppercase' : 'none'}>
                     {finalDebitItems[index] && (
                        <Text fontWeight={finalDebitItems[index]?.isTotal ? 'bold' : '500'}>
                           {finalDebitItems[index].account}
                        </Text>
                     )}
                  </Td>

                  {/* Debit Side - Amount */}
                  <Td
                     p="8px"
                     fontSize={'14px'}
                     color={textColor}
                     borderColor={borderColor}
                     width="15%"
                     isNumeric
                     fontWeight={finalDebitItems[index]?.isTotal ? 'bold' : '500'}>
                     {finalDebitItems[index] && (
                        <Text fontWeight={finalDebitItems[index]?.isTotal ? 'bold' : '500'}>
                           {formatCurrency(finalDebitItems[index].amount)}
                        </Text>
                     )}
                  </Td>

                  {/* Credit Side - Account Name */}
                  <Td
                     p="8px"
                     fontSize={'14px'}
                     color={textColor}
                     borderColor={borderColor}
                     width="40%"
                     fontWeight={finalCreditItems[index]?.isTotal ? 'bold' : '500'}
                     textTransform={finalCreditItems[index]?.isTotal ? 'uppercase' : 'none'}>
                     {finalCreditItems[index] && (
                        <Text fontWeight={finalCreditItems[index]?.isTotal ? 'bold' : '500'}>
                           {finalCreditItems[index].account}
                        </Text>
                     )}
                  </Td>

                  {/* Credit Side - Amount */}
                  <Td
                     p="8px"
                     fontSize={'14px'}
                     color={textColor}
                     borderColor={borderColor}
                     width="15%"
                     isNumeric
                     fontWeight={finalCreditItems[index]?.isTotal ? 'bold' : '500'}>
                     {finalCreditItems[index] && (
                        <Text fontWeight={finalCreditItems[index]?.isTotal ? 'bold' : '500'}>
                           {formatCurrency(finalCreditItems[index].amount)}
                        </Text>
                     )}
                  </Td>
               </Tr>
            ))}

            {/* Total Row */}
            <Tr
               fontWeight="bold"
               borderTop="2px solid"
               borderColor={borderColor}
               bg="rgba(0, 63, 140, 0.1)"
               _dark={{ bg: 'rgba(2, 14, 56, 0.9)' }}>
               <Td p="12px" fontSize="16px" color={textColor} fontWeight="bold">
                  <Text textTransform="uppercase">Total</Text>
               </Td>
               <Td p="12px" fontSize="16px" color={textColor} fontWeight="bold" isNumeric>
                  <Text>{formatCurrency(finalDebitTotal)}</Text>
               </Td>
               <Td p="12px" fontSize="16px" color={textColor} fontWeight="bold">
                  <Text textTransform="uppercase">Total</Text>
               </Td>
               <Td p="12px" fontSize="16px" color={textColor} fontWeight="bold" isNumeric>
                  <Text>{formatCurrency(finalCreditTotal)}</Text>
               </Td>
            </Tr>
         </>
      );
   };

   const renderReportContent = () => {
      if (isLoading) {
         return (
            <Tr>
               <Td colSpan={table.getVisibleFlatColumns().length} textAlign="center" py="100px">
                  <Loader />
               </Td>
            </Tr>
         );
      }

      // Safely handle null/undefined ProfitLossMonthly
      if (!ProfitLossMonthly || !Array.isArray(ProfitLossMonthly)) {
         return (
            <Tr>
               <Td colSpan={table.getVisibleFlatColumns().length} textAlign="center" py="100px">
                  <Text>No data available</Text>
               </Td>
            </Tr>
         );
      }

      // Handle empty array case
      if (ProfitLossMonthly.length === 0) {
         return (
            <Tr justifyContent="center" alignItems="center" width="100%" height="100%">
               <Td
                  p="2px"
                  py="3px"
                  fontSize="10px"
                  whiteSpace="nowrap"
                  textOverflow="ellipsis"
                  maxW="150px"
                  overflow="hidden"
                  colSpan={table.getVisibleFlatColumns().length}
                  justifyContent="center"
                  alignItems="center"
                  width="100%">
                  <Grid justifyContent="center" alignItems="center" gap={9}>
                     <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                     <GridItem justifySelf="center">
                        <label>No profit and loss data found</label>
                     </GridItem>
                  </Grid>
               </Td>
            </Tr>
         );
      }

      // Format currency values helper function
      const formatCurrency = (value) => {
         if (value === null || value === undefined) return '-';
         const numValue = Number(value);
         if (isNaN(numValue)) return value;
         return new Intl.NumberFormat('en-IN', {
            maximumFractionDigits: 2,
         }).format(Math.abs(numValue));
      };

      // Helper function to combine monthly data for same account names
      const combineMonthlyData = (groups, allMonths) => {
         // Create a map to group accounts across all groups by account name
         const accountMap = new Map();

         groups.forEach((group) => {
            (group?.data || []).forEach((item) => {
               const accountName = item?.accountName || '-';
               const groupType = group?.type || 'Uncategorized';
               const key = `${groupType}-${accountName}`;

               if (accountMap.has(key)) {
                  // Account already exists, combine the monthly data
                  const existing = accountMap.get(key);
                  const combinedMonthData = { ...existing.monthData };

                  // Combine month data by adding values
                  allMonths.forEach((month) => {
                     const existingValue = parseFloat(existing.monthData?.[month] || 0);
                     const newValue = parseFloat(group?.monthData?.[month] || 0);
                     combinedMonthData[month] = (existingValue + newValue).toString();
                  });

                  accountMap.set(key, {
                     ...existing,
                     monthData: combinedMonthData,
                  });
               } else {
                  accountMap.set(key, {
                     accountName,
                     groupType,
                     monthData: group?.monthData || {},
                  });
               }
            });
         });

         // Group back by group type
         const groupedByType = new Map();
         accountMap.forEach((account) => {
            const groupType = account.groupType;
            if (!groupedByType.has(groupType)) {
               groupedByType.set(groupType, []);
            }
            groupedByType.get(groupType).push(account);
         });

         return Array.from(groupedByType.entries()).map(([groupType, accounts]) => ({
            type: groupType,
            data: accounts,
         }));
      };

      // Handle T Format report type
      if (reportType === 'Profit & Loss Vertical') {
         if (!ProfitLossMonthly[0]?.data || !Array.isArray(ProfitLossMonthly[0].data)) {
            return (
               <Tr>
                  <Td colSpan={2} textAlign="center" py="100px">
                     <Text>No data available for vertical format</Text>
                  </Td>
               </Tr>
            );
         }
         return renderVerticalFormatProfitLossMonthly();
      }

      if (reportType === 'Profit & Loss T Format') {
         if (!ProfitLossMonthly[0]?.data || !Array.isArray(ProfitLossMonthly[0].data)) {
            return (
               <Tr>
                  <Td colSpan={4} textAlign="center" py="100px">
                     <Text>No data available for T format</Text>
                  </Td>
               </Tr>
            );
         }
         return renderTFormatProfitLossMonthly();
      }

      if (reportType === 'Profit & Loss Monthly') {
         if (!ProfitLossMonthly[0]?.data || !Array.isArray(ProfitLossMonthly[0].data)) {
            return (
               <Tr>
                  <Td colSpan={table.getVisibleFlatColumns().length} textAlign="center" py="100px">
                     <Text>No data available for monthly format</Text>
                  </Td>
               </Tr>
            );
         }

         // First collect all unique months from all groups across all companies
         const allMonths = Array.from(
            new Set(
               ProfitLossMonthly.flatMap((company) =>
                  (company?.data || []).flatMap((group) => (group?.monthData ? Object.keys(group.monthData) : [])),
               ),
            ),
         ).sort((a, b) => {
            // Sort months chronologically
            const monthsOrder = ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];
            const monthA = a.split('-')[0];
            const monthB = b.split('-')[0];
            return monthsOrder.indexOf(monthA) - monthsOrder.indexOf(monthB);
         });

         return (
            <>
               {ProfitLossMonthly.map((company, companyIndex) => {
                  // Group accounts to avoid duplication
                  const groupedData = combineMonthlyData(company?.data || [], allMonths);

                  return (
                     <Box key={`company-${companyIndex}`}>
                        {/* Company Header */}
                        <Text fontSize="xl" fontWeight="bold" bg={companyBg} color={textColor} px={2}>
                           {company?.companyName || 'Unnamed Company'}
                        </Text>

                        {/* Main table containing all data */}
                        <Table variant="simple" size="sm">
                           <Thead>
                              <Tr bg="#F5F5F5" _dark={{ bg: 'rgba(2, 14, 56, 0.8)' }}>
                                 <Th color={textColor} borderColor={borderColor} width="30%">
                                    Account
                                 </Th>
                                 {allMonths.map((month) => (
                                    <Th
                                       key={month}
                                       color={textColor}
                                       borderColor={borderColor}
                                       isNumeric
                                       width={`${70 / allMonths.length}%`}>
                                       {month}
                                    </Th>
                                 ))}
                              </Tr>
                           </Thead>

                           <Tbody>
                              {groupedData.map((group, groupIndex) => (
                                 <React.Fragment key={`group-${groupIndex}`}>
                                    {/* Group Header Row */}
                                    <Tr bg="rgba(0, 63, 140, 0.15)" _dark={{ bg: 'rgba(2, 14, 56, 0.8)' }}>
                                       <Td
                                          colSpan={allMonths.length + 1}
                                          p="4px"
                                          fontSize={'16px'}
                                          fontWeight="bold"
                                          color={textColor}
                                          borderColor={borderColor}>
                                          {group?.type || 'Uncategorized'}
                                       </Td>
                                    </Tr>

                                    {/* Account Rows - Now grouped by account name */}
                                    {(group?.data || []).map((item, itemIndex) => (
                                       <Tr
                                          key={`item-${itemIndex}`}
                                          bg={itemIndex % 2 === 0 ? 'white' : 'rgba(0, 63, 140, 0.05)'}
                                          _dark={{ bg: itemIndex % 2 === 0 ? '#101F4A' : 'rgba(2, 14, 56, 0.7)' }}>
                                          <Td
                                             p="2px"
                                             fontSize={'14px'}
                                             color={textColor}
                                             borderColor={borderColor}
                                             pl="20px">
                                             {item?.accountName || '-'}
                                          </Td>
                                          {allMonths.map((month) => (
                                             <Td
                                                key={month}
                                                p="2px"
                                                fontSize={'14px'}
                                                color={textColor}
                                                borderColor={borderColor}
                                                isNumeric>
                                                {formatCurrency((item?.monthData && item.monthData[month]) || '0')}
                                             </Td>
                                          ))}
                                       </Tr>
                                    ))}
                                 </React.Fragment>
                              ))}
                           </Tbody>
                        </Table>
                     </Box>
                  );
               })}
            </>
         );
      }

      // Default table rendering for other cases
      return (
         <>
            {table.getRowModel().rows.map((row, index) => (
               <Tr
                  key={row.id}
                  bg={index % 2 === 0 ? 'white' : 'rgba(0, 63, 140, 0.05)'}
                  _dark={{ bg: index % 2 === 0 ? '#101F4A' : 'rgba(2, 14, 56, 0.7)' }}>
                  {row.getVisibleCells().map((cell) => (
                     <Td key={cell.id} p="10px" borderColor={borderColor}>
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                     </Td>
                  ))}
               </Tr>
            ))}
         </>
      );
   };

   return (
      <>
         {/* Title Outside Card */}
         <Flex pr="25px" mb="5px" justifyContent="space-between" align="center" mt="50px" overflow={'hidden'}>
            <Flex>
               <img
                  src={back}
                  alt="Go Back"
                  width="15px"
                  onClick={() => window.history.back()}
                  style={{ cursor: 'pointer' }}
               />
               <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
                  Profit & Loss
               </Text>
            </Flex>
            <Flex></Flex>
         </Flex>

         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex alignItems="center" gap={3} justifyContent={'end'}>
               <div flex="1" mr={''} justifyContent="center">
                  <Box my={2} width="300px" fontSize={'13px'} fontWeight={500} display={{ base: 'none', xl: 'block' }}>
                     <GridItem className="seperator-width" mt={5}>
                        {renderDynamicDropdown(
                           'company',
                           'Company',
                           lastcompanyOptions,
                           {
                              value: companyFilter,
                              onChange: handleCompanyChange,
                           },
                           {},
                           textColor,
                           false,
                           'Select company',
                           true,
                           undefined,
                           true,
                        )}
                     </GridItem>
                  </Box>
               </div>
               <Box flex="1" display={{ base: 'none', xl: 'flex' }}>
                  <Flex alignItems={'center'} mt={3}>
                     <PeriodDatePicker
                        value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                        onChange={handleDateRangeChange}
                        defaultPeriod="last7Days"
                        style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                     />
                  </Flex>
                  <Box my={2} zIndex={3} fontSize={'13px'} fontWeight={500}>
                     <label>Report Type</label>
                     <Select
                        options={reportTypeOptions}
                        value={reportTypeOptions.find((option) => option.value === reportType)}
                        onChange={(selectedOption) => {
                           setReportType(selectedOption.value);
                           setExpandedItems({});
                        }}
                        placeholder="Select Report Type"
                        styles={{
                           control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: '30px',
                              height: '30px',
                              backgroundColor: controlBg,
                              borderColor: controlBorder,
                              boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                              '&:hover': {
                                 borderColor: controlBorderHover,
                              },
                           }),
                           valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                              padding: '0 6px',
                              color: textColor,
                           }),
                           indicatorsContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                           }),
                           singleValue: (baseStyles) => ({
                              ...baseStyles,
                              color: textColor,
                           }),
                           placeholder: (baseStyles) => ({
                              ...baseStyles,
                              color: placeholderColor,
                           }),
                           option: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                              color: textColor,
                              '&:hover': {
                                 backgroundColor: optionHoverBg,
                              },
                           }),
                           menu: (baseStyles) => ({
                              ...baseStyles,
                              backgroundColor: menuBg,
                              border: `1px solid ${menuBorder}`,
                           }),
                           dropdownIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                           clearIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                        }}
                     />
                  </Box>
               </Box>
               <Flex>
                  <Box flex="1" mr={3}>
                     <MotionFlex
                        ref={wrapperRef}
                        align="center"
                        bg={bg}
                        borderRadius="full"
                        cursor="pointer"
                        px={expanded ? 3 : 0}
                        w={expanded ? '250px' : '40px'}
                        h="40px"
                        transition="all 0.3s ease"
                        onClick={() => setExpanded(true)}>
                        <MotionSearchIcon
                           color={icon}
                           animate={{ rotate: expanded ? 0 : 90 }}
                           transition={{ duration: 0.3 }}
                           style={{
                              marginRight: expanded ? '8px' : '10px',
                              marginLeft: expanded ? '0' : '10px',
                           }}
                        />
                        {expanded && (
                           <Input
                              variant="unstyled"
                              placeholder="Search accounts..."
                              value={searchQuery}
                              onChange={handleSearchChange}
                              color={icon}
                              flex="1"
                           />
                        )}
                     </MotionFlex>
                  </Box>
                  <Button onClick={handleRefresh} _hover={{ bg: 'blue.50' }} mr={2}>
                     <LuRefreshCcw size={20} mr={2} />
                  </Button>

                  <Button cursor={'pointer'} onClick={onFilterOpen} mr={2}>
                     <IoFilterOutline size={22} />
                  </Button>

                  <Flex alignItems="center">
                     <Flex mr={2}></Flex>
                     <Flex mr={2}>
                        <Popover>
                           <PopoverTrigger>
                              <IconButton
                                 icon={<Image src={Download} boxSize="24px" />}
                                 aria-label="Download Options"
                              />
                           </PopoverTrigger>
                           <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                              <PopoverBody p="3">
                                 <Button
                                    width="100%"
                                    variant="ghost"
                                    _hover={{ bg: 'blue.100' }}
                                    onClick={downloadExcel}
                                    justifyContent="space-between"
                                    mb={3}>
                                    <img src={xls} alt="Download XLS" width="30px" />
                                    Download Excel
                                 </Button>
                                 <Button
                                    width="100%"
                                    variant="ghost"
                                    _hover={{ bg: 'blue.100' }}
                                    onClick={downloadPDF}
                                    justifyContent="space-between">
                                    <img src={xls} alt="Download PDF" width="30px" />
                                    Download PDF
                                 </Button>
                              </PopoverBody>
                           </PopoverContent>
                        </Popover>
                     </Flex>
                  </Flex>
               </Flex>
               <Box ml={1}>
                  <Flex display={{ base: 'block', xl: 'none' }}>
                     <Button variant="unstyled" onClick={onOpen}>
                        <Image src={DotIcon} alt="Menu" width="25px" />
                     </Button>
                  </Flex>
               </Box>

               <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} finalFocusRef={fromDateInputRef}>
                  <DrawerOverlay />
                  <DrawerContent borderTopRadius="20px">
                     <DrawerCloseButton />
                     <DrawerHeader borderBottomWidth="1px">Filters</DrawerHeader>
                     <DrawerBody>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter,
                                 onChange: handleCompanyChange,
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </GridItem>
                        <Box my={2} fontSize={'13px'} fontWeight={500}>
                           <label>Report Type</label>
                           <Select
                              options={reportTypeOptions}
                              value={reportTypeOptions.find((option) => option.value === reportType)}
                              onChange={(selectedOption) => {
                                 setReportType(selectedOption.value);
                                 setExpandedItems({});
                              }}
                              placeholder="Select Report Type"
                           />
                        </Box>
                        <Box alignItems={'center'} mt={3}>
                           <PeriodDatePicker
                              value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                              onChange={handleDateRangeChange}
                              defaultPeriod="last7Days"
                              style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                           />
                        </Box>

                        <Button colorScheme="green" width="100%" onClick={onClose} mt={4}>
                           Apply Filters
                        </Button>
                     </DrawerBody>
                  </DrawerContent>
               </Drawer>
            </Flex>
         </Box>

         <Grid overflow="auto">
            <Card mt="15px" borderRadius="7px">
               <Box
                  overflowX="auto"
                  className="custom-scrollbar"
                  position="relative"
                  minH={{ base: '60vh', md: '65vh', xl: '70vh' }}
                  maxH={{ base: '60vh', md: '65vh', xl: '70vh' }}>
                  {reportType === 'Profit & Loss Vertical' ? (
                     <Table variant="simple" color="gray.500" mb="24px" mt="12px">
                        <Thead>
                           <Tr
                              bg={'#F5F5F5'}
                              position="sticky"
                              top="-1"
                              zIndex="1"
                              color={textColor}
                              borderTop="1px solid"
                              borderBottom="1px solid"
                              borderColor={borderColor}>
                              <Th
                                 cursor="pointer"
                                 p="2px"
                                 py="4px"
                                 _dark={{ bg: '#080238' }}
                                 fontWeight="600"
                                 whiteSpace="nowrap">
                                 <Text fontSize={{ sm: '10px', lg: '12px' }} color={textColor}>
                                    Account
                                 </Text>
                              </Th>
                              <Th
                                 cursor="pointer"
                                 p="2px"
                                 py="4px"
                                 _dark={{ bg: '#080238' }}
                                 fontWeight="600"
                                 whiteSpace="nowrap"
                                 isNumeric>
                                 <Text fontSize={{ sm: '10px', lg: '12px' }} color={textColor}>
                                    Amount
                                 </Text>
                              </Th>
                           </Tr>
                        </Thead>
                        <Tbody>{renderReportContent()}</Tbody>
                     </Table>
                  ) : (
                     <Table variant="simple" color="gray.500" mb="24px" mt="12px">
                        <Thead>
                           {table.getHeaderGroups().map((headerGroup) => (
                              <Tr key={headerGroup.id}>
                                 {headerGroup.headers.map((header) => {
                                    if (!header.column.getIsVisible()) return null;

                                    const columnId = header.column.id;
                                    const isNumericColumn = ['debit', 'credit'].includes(columnId);

                                    return (
                                       <Th
                                          borderTop="1px solid"
                                          key={header.id}
                                          colSpan={header.colSpan}
                                          borderColor={borderColor}
                                          cursor="pointer"
                                          p="2px"
                                          py="4px"
                                          fontSize="10px"
                                          _dark={{ bg: '#080238' }}
                                          fontWeight="600"
                                          bg={'#F5F5F5'}
                                          position="sticky"
                                          top="-1"
                                          zIndex="1"
                                          color={textColor}
                                          isNumeric={isNumericColumn}
                                          whiteSpace="nowrap"
                                          onClick={header.column.getToggleSortingHandler()}>
                                          <Flex
                                             justifyContent={isNumericColumn ? 'flex-end' : 'space-between'}
                                             align="center"
                                             fontSize={{ sm: '10px', lg: '12px' }}
                                             color={textColor}>
                                             {flexRender(header.column.columnDef.header, header.getContext())}
                                             {{
                                                asc: '↑',
                                                desc: '↓',
                                             }[header.column.getIsSorted()] ?? null}
                                          </Flex>
                                       </Th>
                                    );
                                 })}
                              </Tr>
                           ))}
                        </Thead>
                        <Tbody>{renderReportContent()}</Tbody>
                     </Table>
                  )}
               </Box>
            </Card>
         </Grid>

         {/* Column Visibility Modal */}
         <ColumnVisibilityModal />

         <AccountingReportsFilter
            type={reportType}
            // osType={osType}
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            companyIds={companyIds}
            fromDate={datePartyWiseSalesRange.fromDate}
            toDate={datePartyWiseSalesRange.toDate}
            entityType="profitLoss"
         />
      </>
   );
};

export default ProfitLossMonthly;
